import React from "react";
import { Flex, Spinner, SpinnerProps, Text, VStack } from "@chakra-ui/react";

interface ILoadingProps extends SpinnerProps {
  label?: string;
  labelSize?: string;
}

const Loader: React.FC<ILoadingProps> = ({
  label = "Loading...",
  labelSize = "lg",
  ...props
}) => {
  return (
    <Flex
      position="fixed"    // ✅ IMPORTANT
      top="0"
      left="0"
      width="100vw"
      height="100vh"      // ✅ FULL SCREEN
      alignItems="center"
      justifyContent="center"
      direction="column"
      bg="white"          // ✅ avoid blank look
      zIndex="9999"       // ✅ stay on top
    >
      <VStack spacing={4}>
        <Spinner size="xl" thickness="4px" color="teal.500" {...props} />

        {label && (
          <Text fontSize={labelSize} color="gray.600">
            {label}
          </Text>
        )}
      </VStack>
    </Flex>
  );
};

export default Loader;